<mat-label>{{label |transloco}}</mat-label>


<agm-map class="form-map" [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [mapTypeId]='"terrain"' [mapTypeControl]='true' [fullscreenControl]='true' [disableDefaultUI]="true" [zoomControl]="true" (mapClick)="setLocation($event)">
    <ng-container *ngIf="form.get(controlName).value != null">
        <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true" (dragEnd)='setLocation($event)'>
        </agm-marker>
    </ng-container>
    <!-- <agm-circle [latitude]="lat" [longitude]="lng" [radius]="areaRadius" [fillColor]="'red'" [fillOpacity]="0.5" [circleDraggable]="true" [editable]="true" (dragEnd)='circleDragEnd($event)' (radiusChange)='circleRadiusChanged($event)'>
    </agm-circle> -->

</agm-map>